import getOr from 'lodash/fp/getOr.js';

import { connect } from 'react-redux';
import EnhancedLabel from './EnhancedLabel.jsx';

const mapStateToProps = (state, ownProps) => {
  const { field } = ownProps;
  const formState = getOr({ values: {} }, `form.${field.form}`, state);
  return {
    state: formState,
  };
};

export default connect(mapStateToProps)(EnhancedLabel);
